import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Pencil, ArrowUpRight } from "lucide-react";
import { useI18n } from "../contexts/I18nContext";

export default function AppCard({ app }) {
  const { t } = useI18n();
  const installLink = `${window.location.origin}/a/${app.slug}`;
  const initial = (app.short_name || app.name || "A").trim().charAt(0).toUpperCase();
  const host = (() => {
    try { return new URL(app.url).hostname.replace("www.", ""); }
    catch { return app.url; }
  })();

  return (
    <div className="surface-card surface-card-hover p-5 flex flex-col gap-4 h-full" data-testid={`app-card-${app.id}`}>
      <div className="flex items-start gap-3">
        <div
          className="w-12 h-12 rounded-2xl grid place-items-center overflow-hidden flex-shrink-0"
          style={{
            background: app.theme_color || "#0A0A0A",
            boxShadow: "0 6px 14px -6px rgba(0,0,0,0.2), inset 0 0 0 1px rgba(255,255,255,0.06)",
          }}
        >
          {app.icon_url ? (
            <img
              src={app.icon_url}
              alt={app.name}
              className="w-full h-full object-cover"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
          ) : (
            <span className="font-display font-bold text-xl text-white">{initial}</span>
          )}
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="font-display font-semibold text-lg tracking-tight truncate" data-testid={`app-card-name-${app.id}`}>
            {app.name}
          </h3>
          <p className="text-xs text-zinc-500 truncate font-mono">{host}</p>
        </div>
        <a
          href={installLink}
          target="_blank"
          rel="noreferrer"
          data-testid={`app-card-install-${app.id}`}
          className="w-8 h-8 rounded-full grid place-items-center text-zinc-500 hover:text-zinc-900 hover:bg-zinc-100 transition-colors"
          aria-label="Open install link"
        >
          <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
        </a>
      </div>

      {app.description && (
        <p className="text-sm text-zinc-600 line-clamp-2 leading-relaxed">{app.description}</p>
      )}

      <div className="flex gap-2 mt-auto pt-1">
        <Link
          to={`/builder/${app.id}`}
          data-testid={`app-card-edit-${app.id}`}
          className="btn btn-secondary btn-sm flex-1"
        >
          <Pencil className="w-3.5 h-3.5" strokeWidth={2} />
          {t("builder_edit_title")}
        </Link>
        <a
          href={installLink}
          target="_blank"
          rel="noreferrer"
          className="btn btn-primary btn-sm"
          aria-label="Install link"
        >
          <ExternalLink className="w-3.5 h-3.5" strokeWidth={2} />
        </a>
      </div>
    </div>
  );
}
